(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["2021-how-to-content"] && !Shopify.designMode) return;
  try {
    
(function ($) {
  const $scrolly = $("#howToScrolly");
  const headerOffset =
    document.getElementById("shopify-section-header-2023").offsetTop +
    $("#shopify-section-header-2023").height();
  const scrollyOffset = $scrolly.offset().top;

  document.addEventListener("scroll", function (e) {
    if ($(window).width() > 991) {
      // This is for when it enters the fixed place
      if (
        window.scrollY > scrollyOffset - headerOffset - 48 &&
        window.scrollY <
          $(".instruction-article").offset().top +
            $(".instruction-article").height() -
            $scrolly.height() -
            60
      ) {
        if (!$scrolly.hasClass("fixed-scrolly")) {
          $scrolly.css({
            top: headerOffset + "px",
            width: Math.round($scrolly.width()) + "px",
          });
          

          $scrolly.removeClass("bottom-scrolly");
          $scrolly.addClass("fixed-scrolly");
        }
      } else if (
        window.scrollY >
        $(".instruction-article").offset().top +
          $(".instruction-article").height() -
          $scrolly.height() -
          60
      ) {
        if (!$scrolly.hasClass("bottom-scrolly")) {
          $scrolly.removeClass("fixed-scrolly");
          $scrolly.addClass("bottom-scrolly");
        }
      } else {
        $scrolly.removeClass("fixed-scrolly");
        $scrolly.removeClass("bottom-scrolly");

        $scrolly.css({
          top: "",
          width: "",
        });
      }
    }
  });
})(jQuery);


  } catch(e) { console.error(e); }
})();
})();
